<template>
    <th class="px-6 py-3 text-xs leading-4 font-medium uppercase tracking-wider"
        :class="[sort ? 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-500 transition' : '']"
        @click="toggleSortDirection">
        <div class="flex items-center">
            <span v-if="sort" class="mr-1">
                <icon name="menu" :stroke-width="1" fill="currentColor" v-show="!sortActive"/>
                <icon name="sort-descending" :stroke-width="1" fill="currentColor" v-show="sortDesc && sortActive"/>
                <icon name="sort-ascending" :stroke-width="1" fill="currentColor" v-show="!sortDesc && sortActive"/>
            </span>
            <span class="w-full" :class="getSlotAlign">
                <slot/>
            </span>
        </div>
    </th>
</template>

<script>
export default {
    name: 'TableHead',

    props: {
        slotAlign: {
            type: String,
            default: 'left',
        },
        sort: {
            type: String,
            default: null,
        },
        sortQuery: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            sortDesc: false,
            sortActive: false,
        };
    },

    computed: {
        getSlotAlign() {
            switch (this.slotAlign) {
                case 'left':
                    return 'text-left';
                case 'center':
                    return 'text-center';
                case 'right':
                    return 'text-right';
            }
        },

        _sortQuery: {
            get() {
                return this.sortQuery;
            },
            set(value) {
                this.$emit('sorted', value);
            },
        },
    },

    methods: {
        toggleSortDirection() {
            if (!this.sort) {
                return;
            }

            this.cleanQuery();

            if (this.sortDesc && this.sortActive) {
                console.log('NO');
                this.sortActive = false;
                return;
            }

            this.sortActive = true;
            this.sortDesc = !this.sortDesc;

            this._sortQuery.push((this.sortDesc ? '-' : '') + this.sort);
        },

        cleanQuery() {
            if (this._sortQuery) {
                if (this._sortQuery.includes(this.sort)) {
                    this._sortQuery.splice(this._sortQuery.indexOf(this.sort), 1);
                } else if (this._sortQuery.includes('-' + this.sort)) {
                    this._sortQuery.splice(this._sortQuery.indexOf('-' + this.sort), 1);
                }
            } else {
                this._sortQuery = [];
            }

            return true;
        },
    },

    watch: {
        sortQuery: {
            immediate: true,
            handler() {
                if (this.sort && this._sortQuery) {
                    if (this._sortQuery.includes('-' + this.sort) || this._sortQuery.includes(this.sort)) {
                        this.sortActive = true;

                        // Check if current sort contains component desc sort
                        if (this._sortQuery.includes('-' + this.sort)) {
                            this.sortDesc = true;
                        }
                    }
                }
            }
        }
    },
};
</script>
